import { useState } from "react";
import { toast } from "sonner";
import { Headphones, Check, Mail, MessageCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";

export const SupportSection = ({ user }) => {
  const [supportMsg, setSupportMsg] = useState("");
  const [supportSent, setSupportSent] = useState(false);

  return (
    <Card className="card-surface" data-testid="support-card">
      <CardHeader style={{ borderBottom: '1px solid var(--t-border)', padding: '16px 20px' }}>
        <div className="flex items-center gap-3">
          <Headphones className="w-5 h-5" style={{ color: 'var(--t-primary)' }} />
          <div>
            <CardTitle className="text-lg font-semibold" style={{ color: 'var(--t-text)', fontFamily: 'var(--t-heading-font)' }}>
              Help & Support
            </CardTitle>
            <CardDescription style={{ color: 'var(--t-text-muted)' }}>We're here to help you close deals smoothly</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-5">
        {supportSent ? (
          <div className="text-center py-6" data-testid="support-sent-confirmation">
            <div className="w-12 h-12 rounded-full bg-green-50 border border-green-200 flex items-center justify-center mx-auto mb-3">
              <Check className="w-6 h-6 text-green-600" />
            </div>
            <p className="text-sm font-semibold" style={{ color: 'var(--t-text)' }}>Message sent!</p>
            <p className="text-xs mt-1" style={{ color: 'var(--t-text-muted)' }}>We'll get back to you as soon as possible.</p>
            <Button variant="ghost" size="sm" className="mt-3 text-xs" onClick={() => { setSupportSent(false); setSupportMsg(""); }}>
              Send another message
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--t-text-muted)' }}>
              Have a question, need help with a feature, or running into an issue? Drop us a note and our team will get back to you shortly.
            </p>
            <Textarea
              value={supportMsg}
              onChange={(e) => setSupportMsg(e.target.value)}
              placeholder="Describe what you need help with..."
              className="min-h-[80px] text-sm"
              style={{ background: 'var(--t-bg)', borderColor: 'var(--t-border)', color: 'var(--t-text)' }}
              data-testid="support-message-input"
            />
            <div className="flex items-center justify-between">
              <Button
                onClick={() => {
                  if (!supportMsg.trim()) { toast.error("Please enter a message"); return; }
                  const subject = encodeURIComponent("Support Request — EasyOffice");
                  const body = encodeURIComponent(`From: ${user?.name || ""} (${user?.email || ""})\n\n${supportMsg}`);
                  window.open(`mailto:service@easyoffice.systems?subject=${subject}&body=${body}`, "_blank");
                  setSupportSent(true);
                }}
                className="btn-primary"
                disabled={!supportMsg.trim()}
                data-testid="send-support-btn"
              >
                <MessageCircle className="w-4 h-4 mr-2" />
                Send Message
              </Button>
              <span className="text-[11px] flex items-center gap-1.5" style={{ color: 'var(--t-text-subtle)' }}>
                <Mail className="w-3 h-3" />
                service@easyoffice.systems
              </span>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
